/* eslint-disable */
export default {
  conferenceCall: '전화 회의',
  onHold: '대기 중',
  ongoing: '진행 중',
  unknown: '알 수 없음',
  disconnected: '연결 끊김',
  loading: '로드 중...',
  loadingTimeout: '로드 시간이 초과되었습니다.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
